import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { SectorService } from 'src/app/shared/API-Service/services/sector.service';
import { timestamp } from 'rxjs/operators';


@Component({
  selector: 'app-insert-sector',
  templateUrl: './insert-sector.component.html',
  styleUrls: ['./insert-sector.component.css']
})
export class InsertSectorComponent implements OnInit {
  recordtoupdate: any;
 sectorForm : FormGroup;
sectorFormData : FormData;
update:boolean = false;
button:boolean = false;
  constructor(private _SectorService:SectorService,private _Router:Router,private _FormBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }
  initiate(){
    this.sectorForm = this._FormBuilder.group({
      title: ['', Validators.required],
    });
  }
  get fc() {
    return this.sectorForm.controls;
  }
  checkEdit() {
    this._SectorService.Data.subscribe((res) => {
      if (res != null) {
        this.sectorForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
        });
        
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  onSubmit(){
    this.button = true;
   if(this.update == false && this.sectorForm.status == "VALID"){

    this._SectorService.CreateSector(this.sectorForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح  ",
        showConfirmButton: false,
        timer: 1500,
      });
      this.sectorForm.reset();
      this._Router.navigate(['/content/admin/ViewSector']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.sectorForm.status == "VALID"){
    this.sectorForm.addControl('Id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._SectorService.UpdateSector(this.sectorForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.sectorForm.reset();
      this._Router.navigate(['/content/admin/ViewSector']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.sectorForm.markAllAsTouched();
    this.button = false;
   }
  }


  ngOnDestroy(){
    this._SectorService.Data.next(null);
     }
}
